import { makeStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';

export const EditSessionButton = withStyles(() => ({
  root: {
    border: 'solid 1px rgba(44, 45, 62, 0.3)',
    color: '#2C2D3E',
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontSize: '12px',
    zIndex: 10,
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
  },
}))(Button);

export const useStyles = makeStyles(() =>
  createStyles({
    editButton: {
      margin: '20px',
      width: '85px',
      color: '#2C2D3E',
      border: 'solid 1px rgba(44, 45, 62, 0.3)',
    },
    deleteButton: {
      margin: '20px',
      width: '85px',
      color: '#d32f2f',
      border: 'solid 1px rgba(211, 47, 47, 0.5)',
    },
    editButtonIcon: {
      width: '14px',
      justifyContent: 'start',
      color: '#81818D',
      transform: 'translateX(0px)',
    },
    disableButtonIcon: {
      color: '#81818D',
    },
    deleteButtonIcon: {
      width: '17px',
      justifyContent: 'start',
      color: 'rgba(211, 47, 47, 0.5)',
      transform: 'translate(0px, 0px)',
    },
  }),
);
